var Transparency;
(function (Transparency) {
    Transparency["ALWAYS"] = "always";
    Transparency["NEVER"] = "never";
    Transparency["AT_TOP"] = "at-top";
})(Transparency || (Transparency = {}));

export { Transparency as T };

//# sourceMappingURL=roche-header.types.js.map